"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ui = void 0;

var react_1 = __importDefault(require("react"));

var react_material_icon_1 = __importDefault(require("@material/react-material-icon"));

var fclasses_1 = require("@bodiless/fclasses");

var ui_1 = require("@bodiless/ui");

var layouts_1 = require("@bodiless/layouts");
/**
 * Checkbox component used on flow container.
 *
 * Used instead of informed Checkbox for more concise handling.
 */


var CheckBox = function CheckBox(_a) {
  var name = _a.name,
      checked = _a.checked,
      onChange = _a.onChange,
      disabled = _a.disabled,
      id = _a.id,
      rest = __rest(_a, ["name", "checked", "onChange", "disabled", "id"]);

  return react_1.default.createElement(ui_1.Input, __assign({
    type: "checkbox",
    name: name,
    disabled: disabled,
    checked: checked,
    onChange: onChange,
    id: id
  }, rest));
}; // eslint-disable-next-line import/prefer-default-export


exports.ui = {
  MasterWrapper: fclasses_1.addClasses('bl-flex bl-form-wrapper')(ui_1.Div),
  FlexSection: fclasses_1.addClasses('bl-pt-grid-2')(ui_1.Div),
  FlexSectionFull: fclasses_1.addClasses('bl-pt-grid-2 bl-w-full')(ui_1.Div),
  FlowContainerEmpty: fclasses_1.addClasses('bl-border-2 bl-border-dashed bl-text-gray-600')(ui_1.Div),
  ItemBoxWrapper: fclasses_1.addClasses('bl-p-grid-2')(ui_1.Div),
  ItemBox: fclasses_1.addClasses('bl-bg-grey-200 bl-flex bl-flex-col bl-items-center bl-p-grid-2 bl-h-full bl-w-full bl-relative bl-overflow-hidden bl-cursor-pointer')(ui_1.Div),
  GridListBoxWrapper: fclasses_1.addClasses('bl-w-full bl-h-xl-grid-2')(ui_1.Div),
  GridListBoxInner: fclasses_1.addClasses('bl-w-full bl-overflow-y-scroll bl-flex bl-flex-wrap bl-h-xl-grid-2')(ui_1.Div),
  GridListBox: fclasses_1.addClasses('bl-text-xs bl-flex bl-flex-wrap bl-mb-grid-2 bl-bg-white')(ui_1.Div),
  TitleWrapper: fclasses_1.addClasses('bl-font-semibold bl-text-sm bl-text-grey-800')(ui_1.Span),
  ComponentTitleWrapper: ui_1.ComponentFormTitle,
  ComponentLinkWrapper: ui_1.ComponentFormLink,
  IconWrapper: fclasses_1.addClasses('bl-block bl-absolute bl-left-grid-0 bl-top-grid-0')(ui_1.Span),
  ComponentSelectorWrapper: fclasses_1.addClasses('bl-text-white bl-mr-grid-3  bl-whitespace-no-wrap')(ui_1.Div),
  SubmitButton: fclasses_1.addClasses('bl-right-grid-0 bl-absolute tbl-ext-m bl-mr-grid-2')(ui_1.SubmitButton),
  AccordionWrapper: fclasses_1.addClasses('bl-font-semibold')(ui_1.Div),
  AccordionCheckboxWrapper: fclasses_1.addClasses('bl-italic bl-mt-grid-1')(ui_1.Div),
  AccordionItemWrapper: fclasses_1.addClasses('bl-flex bl-items-center bl-mt-grid-2 bl-text-base')(ui_1.Anchor),
  AccordionCheckboxLabel: fclasses_1.addClasses('bl-ml-grid-2 bl-font-semibold')(ui_1.Label),
  AccordionCheckBox: fclasses_1.addClasses('bl-ml-grid-1 bl-mr-grid-1')(CheckBox),
  SearchBarWrapper: fclasses_1.addClasses('bl-bg-white bl-content-center bl-h-grid-9 bl-font-sans bl-px-grid-2 bl-py-grid-1 bl-text-black')(ui_1.Div),
  SearchBar: fclasses_1.addClasses('bl-border bl-border-grey bl-p-grid-1 bl-w-full')(ui_1.Input),
  AccordionLabel: fclasses_1.addClasses('bl-inline-block')(ui_1.Label),
  AccordionIconContract: function AccordionIconContract() {
    return react_1.default.createElement(react_material_icon_1.default, {
      className: "bl-mr-2",
      icon: "expand_less"
    });
  },
  AccordionIconExpand: function AccordionIconExpand() {
    return react_1.default.createElement(react_material_icon_1.default, {
      className: "bl-mr-2",
      icon: "expand_more"
    });
  },
  ComponentDescriptionWrapper: fclasses_1.addClasses('bl-w-xl-grid-0 bl-min-h-32')(ui_1.Div),
  ComponentDescriptionStyle: fclasses_1.addClasses('bl-bg-white bl-text-red bl-w-xl-grid-0 bl-p-grid-2 bl-mt-grid-2 bl-h-xl-grid-0 bl-mb-grid-2')(ui_1.Div),
  ComponentDescriptionIcon: fclasses_1.addClasses('bl-absolute bl-top-grid-0 bl-right-grid-0 material-icons bl-z-20 bl-text-grey-800 bl-m-grid-1')(ui_1.Div),
  ComponentSelectButton: fclasses_1.addClasses('bl-absolute bl-z-10 bl-top-grid-0 bl-left-grid-0 bl-w-full bl-h-full bl-opacity-0')(ui_1.Button),
  ScalingHeader: fclasses_1.addClasses('bl-w-full bl-cursor-pointer bl-justify-end bl-text-grey-900 bl-p-grid-2 bl-flex')(ui_1.Div),
  ScalingButtonFull: function ScalingButtonFull(props) {
    return react_1.default.createElement(react_material_icon_1.default, __assign({}, props, {
      icon: "view_stream"
    }));
  },
  ScalingButtonHalf: function ScalingButtonHalf(props) {
    return react_1.default.createElement(react_material_icon_1.default, __assign({}, props, {
      icon: "view_module"
    }));
  },
  ScalingButtonQuarter: function ScalingButtonQuarter(props) {
    return react_1.default.createElement(react_material_icon_1.default, __assign({}, props, {
      icon: "view_comfy"
    }));
  }
};

var ComponentSelector = function ComponentSelector(props) {
  return react_1.default.createElement(layouts_1.ComponentSelector, __assign({
    ui: exports.ui
  }, props));
};

exports.default = ComponentSelector;